import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-toggle',
  imports: [CommonModule],
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss',
})
export class ThemeToggleComponent implements OnInit {
  dark = false;

  ngOnInit(): void {
    const savedTheme = localStorage.getItem('theme');

    if (savedTheme) {
      this.dark = savedTheme === 'dark-gold';
    }

    this.applyTheme();
  }

  toggleTheme(): void {
    this.dark = !this.dark;

    this.applyTheme();

    localStorage.setItem(
      'theme',
      this.dark ? 'dark-gold' : 'light-gold'
    );
  }

  private applyTheme(): void {
    document.body.classList.toggle('light-gold', !this.dark);
  }
}